import React from "react";
import {
  heightPercentageToDP,
  widthPercentageToDP,
} from "../../Utils/ResponsiveScreen";
import { Button, Modal } from "react-bootstrap";
import ListPages from "../../Services/Queries/ListPages";
import ListLists from "../../Services/Queries/ListLists";
import ListPeople from "../../Services/Queries/ListPeople";
import ListCollections from "../../Services/Queries/ListCollections";
import DynamicButtonValidations from "./DynamicButtonValidations";
import ImageUpload from "./ImageUpload";
import AwsConfig from "../../Config/AwsConfig";

class CreateDynamicButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: "insideApp",
      urlType: "page",
      pageLink: "",
      peopleLink: "",
      listLink: "",
      collectionLink: "",
      trackerLink: "",
      appstoreLink: "",
      playstoreLink: "",
      saavnLink: "",
      gaanaLink: "",
      instagramLink: "",
      twitterLink: "",
      youtubeLink: "",
      facebookLink: "",
      httpsLink: "",
      contentLink: "",
      videoLink: "",
      linkText: "",
      linkSubText: "",
      linkAvatar: "",
      buttonPositionFromTop: "",
      buttonPositionFromLeft: "",
      pagesList: [],
      pageInfo: {},
      selectedPageValue: null,
      peopleList: [],
      peopleInfo: {},
      lists: [],
      listInfo: {},
      collections: [],
      collectionInfo: {},
      listLanguage: "Te",
      tweetType: "post",
      buttonStyle: "default",
      buttonPosition: "custom",
      buttonDiscardModal: false,
      enableTrackerLink: false,
      markdownLabelModal: false,
      markdownLabel: "",
      enableMarkdownLink: false,
      linkAvatarImageObj: {},
    };
    this.button = {};
  }

  updateDataInParent = () => {
    const input = {
      category: this.state.category,
      urlType: this.state.urlType ? this.state.urlType.trim() : null,
      pageLink: this.state.pageLink ? this.state.pageLink.trim() : null,
      pageInfo: this.state.pageInfo,
      peopleLink: this.state.peopleLink ? this.state.peopleLink.trim() : null,
      peopleInfo: this.state.peopleInfo,
      listLink: this.state.listLink ? this.state.listLink.trim() : null,
      listInfo: this.state.listInfo,
      collectionLink: this.state.collectionLink
        ? this.state.collectionLink.trim()
        : null,
      collectionInfo: this.state.collectionInfo,
      contentLink: this.state.contentLink
        ? this.state.contentLink.trim()
        : null,
      videoLink: this.state.videoLink ? this.state.videoLink.trim() : null,
      trackerLink: this.state.trackerLink
        ? this.state.trackerLink.trim()
        : null,
      appstoreLink: this.state.appstoreLink
        ? this.state.appstoreLink.trim()
        : null,
      playstoreLink: this.state.playstoreLink
        ? this.state.playstoreLink.trim()
        : null,
      saavnLink: this.state.saavnLink ? this.state.saavnLink.trim() : null,
      gaanaLink: this.state.gaanaLink ? this.state.gaanaLink.trim() : null,

      instagramLink: this.state.instagramLink
        ? this.state.instagramLink.trim()
        : null,
      youtubeLink: this.state.youtubeLink
        ? this.state.youtubeLink.trim()
        : null,
      twitterLink: this.state.twitterLink
        ? this.state.twitterLink.trim()
        : null,
      facebookLink: this.state.facebookLink
        ? this.state.facebookLink.trim()
        : null,

      tweetType: this.state.tweetType,
      buttonStyle: this.state.buttonStyle,
      buttonPosition: this.state.buttonPosition,

      httpsLink: this.state.httpsLink ? this.state.httpsLink.trim() : null,
      linkText: this.state.linkText,
      linkSubText: this.state.linkSubText,
      linkAvatar: this.state.linkAvatar,
      buttonPositionFromTop: this.state.buttonPositionFromTop,
      buttonPositionFromLeft: this.state.buttonPositionFromLeft,
      markdownLabel: this.state.markdownLabel,
    };
    this.button = input;
    this.props.updatecontentNewLinkDetails(input, this.props.sectionIndex);
  };

  handleInsideApp = (val) => {
    if (this.state.urlType != val) {
      this.setState(
        {
          urlType: val,
          pageLink: "",
          pageInfo: {},
          peopleLink: "",
          peopleInfo: {},
          listLink: "",
          listInfo: {},
          collectionLink: "",
          collectionInfo: {},
          contentLink: "",
          videoLink: "",
          linkText: "",
          linkSubText: "",
          linkAvatar: "",
        },
        () => this.updateDataInParent()
      );
    }
  };
  handleMusic = (val) => {
    if (this.state.urlType != val) {
      this.setState(
        {
          urlType: val,
          saavnLink: "",
          gaanaLink: "",
          linkText: "",
          linkSubText: "",
          linkAvatar: "",
        },
        () => this.updateDataInParent()
      );
    }
  };

  handleSocialMedia = (val) => {
    if (this.state.urlType != val) {
      this.setState(
        {
          urlType: val,
          instagramLink: "",
          youtubeLink: "",
          twitterLink: "",
          facebookLink: "",
          tweetType: "post",
        },
        () => this.updateDataInParent()
      );
    }
  };

  resetData = (category) => {
    this.setState(
      {
        category: category,
        urlType: "page",
        pageLink: "",
        peopleLink: "",
        listLink: "",
        collectionLink: "",
        trackerLink: "",
        appstoreLink: "",
        playstoreLink: "",
        saavnLink: "",
        gaanaLink: "",
        instagramLink: "",
        twitterLink: "",
        youtubeLink: "",
        facebookLink: "",
        httpsLink: "",
        contentLink: "",
        videoLink: "",
        linkText: "",
        linkSubText: "",
        linkAvatar: "",
        buttonPositionFromTop: "",
        buttonPositionFromLeft: "",
        pageInfo: {},
        selectedPageValue: null,
        peopleInfo: {},
        listInfo: {},
        collectionInfo: {},
        listLanguage: "Te",
        tweetType: "post",
        buttonStyle: "default",
        buttonPosition: "custom",
        markdownLabel: "",
      },
      () => this.updateDataInParent()
    );
  };

  setData = () => {
    if (this.props.editContent) {
      const {
        category,
        urlType,
        pageLink,
        pageInfo,
        peopleLink,
        peopleInfo,
        collectionLink,
        collectionInfo,
        listLink,
        listInfo,
        contentLink,
        videoLink,
        trackerLink,
        appstoreLink,
        playstoreLink,
        saavnLink,
        gaanaLink,
        instagramLink,
        youtubeLink,
        twitterLink,
        facebookLink,
        httpsLink,
        linkText,
        linkSubText,
        linkAvatar,
        buttonPositionFromTop,
        buttonPositionFromLeft,
        tweetType,
        buttonStyle,
        buttonPosition,
        markdownLabel,
      } = this.props.contentNewLinkDetails || "";
      const isDynamicButtonAvailable = urlType ? true : false;
      this.setState({
        dynamicButton: isDynamicButtonAvailable,
        category,
        urlType,
        pageLink,
        pageInfo,
        peopleLink,
        peopleInfo,
        collectionLink,
        collectionInfo,
        listLink,
        listInfo,
        contentLink,
        videoLink,
        trackerLink,
        appstoreLink,
        playstoreLink,
        saavnLink,
        gaanaLink,
        instagramLink,
        youtubeLink,
        twitterLink,
        facebookLink,
        httpsLink,
        linkText,
        linkSubText,
        linkAvatar,
        buttonPositionFromTop,
        buttonPositionFromLeft,
        tweetType,
        buttonStyle,
        buttonPosition,
        markdownLabel,
      });
    }
  };

  getPeopleLists = async (peopleSearchQuery) => {
    const input = {
      limit: 20,
    };
    if (peopleSearchQuery) {
      input.search = peopleSearchQuery;
    }
    const data = await ListPeople(input);
    this.setState({
      peopleList: data.items,
      peopleNextToken: data.nextToken,
    });
  };
  getNextPeopleLists = async () => {
    const input = {
      limit: 20,
      nextToken: this.state.peopleNextToken,
    };
    const data = await ListPeople(input);
    this.setState({
      peopleList: [...this.state.peopleList, ...data.items],
      peopleNextToken: data.nextToken,
    });
  };

  getPagesLists = async (pagesSeachQuery) => {
    const input = {
      limit: 20,
    };
    if (pagesSeachQuery) {
      input.search = pagesSeachQuery;
    }
    const data = await ListPages(input);
    this.setState({
      pagesList: data.items,
      pagesNextToken: data.nextToken,
    });
  };
  getNextPagesLists = async () => {
    const input = {
      limit: 20,
      nextToken: this.state.pagesNextToken,
    };
    const data = await ListPages(input);
    this.setState({
      pagesList: [...this.state.pagesList, ...data.items],
      pagesNextToken: data.nextToken,
    });
  };

  getLists = async (listSeachQuery) => {
    const input = {
      limit: 20,
    };
    if (listSeachQuery) {
      input.search = listSeachQuery;
    }
    const data = await ListLists(input);
    this.setState({
      lists: data.items,
      listNextToken: data.nextToken,
    });
  };
  getNextLists = async () => {
    const input = {
      limit: 20,
      nextToken: this.state.listNextToken,
    };

    const data = await ListLists(input);

    this.setState({
      lists: [...this.state.lists, ...data.items],
      listNextToken: data.nextToken,
    });
  };

  getCollectionsList = async (collectionSeachQuery) => {
    const input = {
      limit: 20,
    };
    if (collectionSeachQuery) {
      input.search = collectionSeachQuery;
    }

    const data = await ListCollections(input);
    this.setState({
      collections: data.items,
      collectionNextToken: data.nextToken,
    });
  };
  getNextCollections = async () => {
    const input = {
      limit: 20,
      nextToken: this.state.collectionNextToken,
    };

    const data = await ListCollections(input);

    this.setState({
      collections: [...this.state.collections, ...data.items],
      collectionNextToken: data.nextToken,
    });
  };

  peopleLoadMore = async () => {
    await this.getNextPeopleLists();
  };
  pagesLoadMore = async () => {
    await this.getNextPagesLists();
  };
  listLoadMore = async () => {
    await this.getNextLists();
  };
  collectionsLoadMore = async () => {
    await this.getNextCollections();
  };
  onChangePeopleSearch = (peopleSearchQuery) => {
    this.setState({ peopleSearchQuery: peopleSearchQuery });
    this.getPeopleLists(peopleSearchQuery);
  };

  onChangePagesSearch = (pageSearchQuery) => {
    this.setState({ pageSearchQuery: pageSearchQuery });
    this.getPagesLists(pageSearchQuery);
  };
  onChangeListSearch = (listSeachQuery) => {
    this.setState({ listSeachQuery: listSeachQuery });
    this.getLists(listSeachQuery);
  };
  onChangeCollectionSearch = (collectionSeachQuery) => {
    this.setState({ collectionSeachQuery: collectionSeachQuery });
    this.getCollectionsList(collectionSeachQuery);
  };

  componentDidMount() {
    this.setData();
    this.getPeopleLists("");
    this.getPagesLists("");
    this.getLists("");
    this.getCollectionsList("");
    const { markdownLabel } = this.props.contentNewLinkDetails;
    this.setState({ enableMarkdownLink: markdownLabel?.length ? true : false });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.contentNewLinkDetails != this.props.contentNewLinkDetails ||
      prevProps.markdownLinkLables != this.props.markdownLinkLables
    )
      this.setData();
  }

  handleCategory = (value) => {
    const buttonDataAvailable =
      this.button && DynamicButtonValidations(this.button, false, true);
    if (this.state.category != value) {
      if (buttonDataAvailable) {
        this.setState({ selectedCategory: value, buttonDiscardModal: true });
      } else {
        this.setState({ category: value, buttonDiscardModal: false }, () => {
          this.resetData(value);
        });
      }
    }
  };

  hideButtonDiscardModal = () => {
    this.setState({ buttonDiscardModal: false });
  };

  discardButtonChanges = () => {
    this.setState(
      { category: this.state.selectedCategory, buttonDiscardModal: false },
      () => {
        this.resetData(this.state.selectedCategory);
      }
    );
  };

  handleChangeDynamicButton = () => {
    this.setState({ dynamicButton: !this.state.dynamicButton }, () => {
      this.resetData("insideApp");
    });
  };

  renderPagesModal = () => {
    return (
      <div>
        <label for="gsearch">Search Pages:</label>
        <input
          type="text"
          onChange={(e) => {
            this.onChangePagesSearch(e.target.value);
          }}
          value={this.state.pageSearchQuery}
          placeholder="Enter Page Name"
        ></input>
        <div>
          {this.state.pagesList?.map((page) => {
            return (
              <div key={page.SK}>
                <input
                  type="radio"
                  checked={this.state.pageLink == page.pageValue}
                  onChange={() => {
                    this.setState(
                      { pageInfo: page, pageLink: page.pageValue },
                      () => {
                        this.updateDataInParent();
                      }
                    );
                  }}
                ></input>
                <text>{page.pageTitle}</text>
              </div>
            );
          })}
        </div>
        {this.state.pagesNextToken != null ? (
          <button
            onClick={this.pagesLoadMore}
            type="button"
            className="load-more"
          >
            Load more
          </button>
        ) : null}
      </div>
    );
  };

  renderPeopleModal = () => {
    return (
      <div>
        <label for="gsearch">Search People:</label>
        <input
          type="text"
          onChange={(e) => {
            this.onChangePeopleSearch(e.target.value);
          }}
          value={this.state.peopleSearchQuery}
          placeholder="Enter Name"
        ></input>
        <div>
          {this.state.peopleList?.map((person) => {
            return (
              <div key={person.SK}>
                <input
                  type="radio"
                  checked={this.state.peopleLink == person.peopleValue}
                  onChange={() => {
                    this.setState(
                      { peopleInfo: person, peopleLink: person.peopleValue },
                      () => {
                        this.updateDataInParent();
                      }
                    );
                  }}
                ></input>
                <text>{person.peopleName}</text>
              </div>
            );
          })}
        </div>
        {this.state.peopleNextToken != null ? (
          <button
            onClick={this.peopleLoadMore}
            type="button"
            className="load-more"
          >
            Load more
          </button>
        ) : null}
      </div>
    );
  };

  renderListModal = () => {
    return (
      <div>
        <label for="gsearch">Search List:</label>
        <input
          type="text"
          onChange={(e) => {
            this.onChangeListSearch(e.target.value);
          }}
          value={this.state.listSearchQuery}
          placeholder="Enter Name"
        ></input>
        <div style={{ marginBottom: 10 }}>
          <span>
            <input
              type="radio"
              onChange={(e) => {
                this.setState({ listLanguage: "Te" });
              }}
              checked={this.state.listLanguage == "Te"}
            ></input>
            <text style={{ marginRight: 5 }}>Telugu</text>
          </span>
          <span>
            <input
              type="radio"
              onChange={(e) => {
                this.setState({ listLanguage: "En" });
              }}
              checked={this.state.listLanguage == "En"}
            ></input>
            <text style={{ marginRight: 5 }}>English</text>
          </span>
          <span>
            <input
              type="radio"
              onChange={(e) => {
                this.setState({ listLanguage: "Hi" });
              }}
              checked={this.state.listLanguage == "Hi"}
            ></input>
            <text style={{ marginRight: 5 }}>Hindi</text>
          </span>
        </div>
        <div>
          {this.state.lists?.map((list) => {
            return (
              list[`listName_${this.state.listLanguage}`] && (
                <div key={list.SK}>
                  <input
                    type="radio"
                    checked={this.state.listLink == list.listValue}
                    onChange={() => {
                      this.setState(
                        { listInfo: list, listLink: list.listValue },
                        () => {
                          this.updateDataInParent();
                        }
                      );
                    }}
                  ></input>
                  <text>{list[`listName_${this.state.listLanguage}`]}</text>
                </div>
              )
            );
          })}
        </div>
        {this.state.listNextToken != null ? (
          <button
            onClick={this.listLoadMore}
            type="button"
            className="load-more"
          >
            Load more
          </button>
        ) : null}
      </div>
    );
  };

  renderCollectionModal = () => {
    return (
      <div>
        <label for="gsearch">Search Collection:</label>
        <input
          type="text"
          onChange={(e) => {
            this.onChangeCollectionSearch(e.target.value);
          }}
          value={this.state.collectionSearchQuery}
          placeholder="Enter Collection name"
        ></input>
        <div>
          {this.state.collections?.map((collection) => {
            return (
              <div key={collection.SK}>
                <input
                  type="radio"
                  checked={
                    this.state.collectionLink == collection.collectionValue
                  }
                  onChange={() => {
                    this.setState(
                      {
                        collectionInfo: collection,
                        collectionLink: collection.collectionValue,
                      },
                      () => {
                        this.updateDataInParent();
                      }
                    );
                  }}
                ></input>
                <text>{collection.collectionName}</text>
              </div>
            );
          })}
        </div>
        {this.state.collectionNextToken != null ? (
          <button
            onClick={this.collectionsLoadMore}
            type="button"
            className="load-more"
          >
            Load more
          </button>
        ) : null}
      </div>
    );
  };

  renderCategoryDetails = () => {
    const { urlType, category } = this.state;
    switch (category) {
      case "insideApp":
        return (
          <div>
            <details>
              <summary>Inside App Options :</summary>
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "page"}
                  onChange={() => {
                    this.handleInsideApp("page");
                  }}
                ></input>
                <text for={"Page Link"}>{"Page Link"}</text>
              </div>
              {urlType == "page" ? (
                <div style={{ marginBottom: 10 }}>
                  <button
                    onClick={() => {
                      this.setState({ pagesModalVisible: true });
                    }}
                  >
                    {"Choose Page Link"}
                  </button>
                  <text style={{ marginLeft: 5 }}>
                    {this.state.pageInfo?.pageTitle}
                  </text>
                </div>
              ) : null}
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "people"}
                  onChange={() => {
                    this.handleInsideApp("people");
                  }}
                ></input>
                <text for={"People Link"}>{"People Link"}</text>
              </div>
              {urlType == "people" ? (
                <div style={{ marginBottom: 10 }}>
                  <button
                    onClick={() => {
                      this.setState({ peopleModalVisible: true });
                    }}
                  >
                    {"Choose People Link"}
                  </button>
                  <text style={{ marginLeft: 5 }}>
                    {this.state.peopleInfo?.peopleName}
                  </text>
                </div>
              ) : null}
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "list"}
                  onChange={() => {
                    this.handleInsideApp("list");
                  }}
                ></input>
                <text for={"List Link"}>{"List Link"}</text>
              </div>
              {urlType == "list" ? (
                <div style={{ marginBottom: 10 }}>
                  <button
                    onClick={() => {
                      this.setState({ listModalVisible: true });
                    }}
                  >
                    {"Choose List Link"}
                  </button>
                  <text style={{ marginLeft: 5 }}>
                    {
                      this.state.listInfo?.[
                        `listName_${this.state.listLanguage}`
                      ]
                    }
                  </text>
                </div>
              ) : null}
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "collection"}
                  onChange={() => {
                    this.handleInsideApp("collection");
                  }}
                ></input>
                <text for={"Collection Link"}>{"Collection Link"}</text>
              </div>
              {urlType == "collection" ? (
                <div style={{ marginBottom: 10 }}>
                  <button
                    onClick={() => {
                      this.setState({ collectionModalVisible: true });
                    }}
                  >
                    {"Choose Collection Link"}
                  </button>
                  <text style={{ marginLeft: 5 }}>
                    {this.state.collectionInfo?.collectionName}
                  </text>
                </div>
              ) : null}
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "content"}
                  onChange={() => {
                    this.handleInsideApp("content");
                  }}
                ></input>
                <text for={"Content Link"}>{"Content Link"}</text>
              </div>
              {urlType == "content" ? (
                <div style={{ marginBottom: 10 }}>
                  <input
                    className="hideInputCursor"
                    value={this.state.contentLink}
                    type="text"
                    onChange={(e) => {
                      this.setState(
                        { contentLink: e.target.value?.trim() },
                        () => this.updateDataInParent()
                      );
                    }}
                  ></input>
                </div>
              ) : null}
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "video"}
                  onChange={() => {
                    this.handleInsideApp("video");
                  }}
                ></input>
                <text for={"Video Link"}>{"Video Link"}</text>
              </div>
              {urlType == "video" ? (
                <div style={{ margin: 10 }}>
                  <input
                    value={this.state.videoLink}
                    type="text"
                    onChange={(e) => {
                      this.setState({ videoLink: e.target.value?.trim() }, () =>
                        this.updateDataInParent()
                      );
                    }}
                  ></input>
                </div>
              ) : null}
            </details>
          </div>
        );
      case "storeLinks":
        return (
          <div>
            <details>
              <summary>Store Links :</summary>
              <div style={{ flexDirection: "row" }}>
                <div style={{ marginRight: 10 }}>
                  <input
                    type="radio"
                    checked={this.state.enableTrackerLink == false}
                    onChange={() => {
                      this.setState({
                        enableTrackerLink: false,
                        trackerLink: "",
                      });
                    }}
                  ></input>
                  <text for={"Individual Links"}>{"Individual Links"}</text>
                </div>
                <div style={{ marginRight: 10 }}>
                  <input
                    type="radio"
                    checked={this.state.enableTrackerLink == true}
                    onChange={() => {
                      this.setState({
                        enableTrackerLink: true,
                        appstoreLink: "",
                        playstoreLink: "",
                      });
                    }}
                  ></input>
                  <text for={"Tracker Link"}>{"Tracker Link"}</text>
                </div>
              </div>
              {this.state.enableTrackerLink ? (
                <div>
                  <div>
                    <input
                      value={this.state.trackerLink}
                      type="text"
                      onChange={(e) => {
                        this.setState(
                          {
                            trackerLink: e.target.value?.trim(),
                            urlType: "storeLink",
                          },
                          () => this.updateDataInParent()
                        );
                      }}
                    ></input>
                  </div>
                </div>
              ) : (
                <div>
                  <div>
                    <div style={{ marginRight: 10 }}>
                      <text for={"AppStore Link"}>{"AppStore Link"}</text>
                    </div>
                    <div>
                      <input
                        value={this.state.appstoreLink}
                        type="text"
                        onChange={(e) => {
                          this.setState(
                            {
                              appstoreLink: e.target.value?.trim(),
                              urlType: "storeLink",
                            },
                            () => this.updateDataInParent()
                          );
                        }}
                      ></input>
                    </div>
                  </div>

                  <div>
                    <div style={{ marginRight: 10 }}>
                      <text for={"PlayStore Link"}>{"PlayStore Link"}</text>
                    </div>
                    <div>
                      <input
                        value={this.state.playstoreLink}
                        type="text"
                        onChange={(e) => {
                          this.setState(
                            {
                              playstoreLink: e.target.value?.trim(),
                              urlType: "storeLink",
                            },
                            () => this.updateDataInParent()
                          );
                        }}
                      ></input>
                    </div>
                  </div>
                </div>
              )}
            </details>
          </div>
        );
      case "music":
        return (
          <div>
            <details>
              <summary>Music :</summary>
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "saavnLink"}
                  onChange={() => {
                    this.handleMusic("saavnLink");
                  }}
                ></input>
                <text for={"Saavn Link"}>{"Saavn Link"}</text>
              </div>
              {urlType == "saavnLink" ? (
                <div>
                  <input
                    value={this.state.saavnLink}
                    type="text"
                    onChange={(e) => {
                      this.setState({ saavnLink: e.target.value?.trim() }, () =>
                        this.updateDataInParent()
                      );
                    }}
                  ></input>
                </div>
              ) : null}
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "gaanaLink"}
                  onChange={() => {
                    this.handleMusic("gaanaLink");
                  }}
                ></input>
                <text for={"Gaana Link"}>{"Gaana Link"}</text>
              </div>
              {urlType == "gaanaLink" ? (
                <div>
                  <input
                    value={this.state.gaanaLink}
                    type="text"
                    onChange={(e) => {
                      this.setState({ gaanaLink: e.target.value?.trim() }, () =>
                        this.updateDataInParent()
                      );
                    }}
                  ></input>
                </div>
              ) : null}
            </details>
          </div>
        );
      case "socialMedia":
        return (
          <div>
            <details>
              <summary>Social Media :</summary>
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "instagramLink"}
                  onChange={() => {
                    this.handleSocialMedia("instagramLink");
                  }}
                ></input>
                <text for={"Instagram Link"}>{"Instagram Link"}</text>
              </div>
              {urlType == "instagramLink" ? (
                <div>
                  <input
                    value={this.state.instagramLink}
                    type="text"
                    onChange={(e) => {
                      this.setState(
                        { instagramLink: e.target.value?.trim() },
                        () => this.updateDataInParent()
                      );
                    }}
                  ></input>
                </div>
              ) : null}
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "youtubeLink"}
                  onChange={() => {
                    this.handleSocialMedia("youtubeLink");
                  }}
                ></input>
                <text for={"Youtube Link"}>{"Youtube Link"}</text>
              </div>
              {urlType == "youtubeLink" ? (
                <div>
                  <input
                    value={this.state.youtubeLink}
                    type="text"
                    onChange={(e) => {
                      this.setState(
                        { youtubeLink: e.target.value?.trim() },
                        () => this.updateDataInParent()
                      );
                    }}
                  ></input>
                </div>
              ) : null}
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "twitterLink"}
                  onChange={() => {
                    this.handleSocialMedia("twitterLink");
                  }}
                ></input>
                <text for={"Twitter Link"}>{"Twitter Link"}</text>
              </div>
              {urlType == "twitterLink" ? (
                <div>
                  <input
                    value={this.state.twitterLink}
                    type="text"
                    onChange={(e) => {
                      this.setState(
                        { twitterLink: e.target.value?.trim() },
                        () => this.updateDataInParent()
                      );
                    }}
                  ></input>
                  <div>
                    <input
                      checked={this.state.tweetType == "post"}
                      type="radio"
                      onChange={(e) => {
                        this.setState({ tweetType: "post" }, () =>
                          this.updateDataInParent()
                        );
                      }}
                    ></input>
                    <text>Post</text>
                    <input
                      checked={this.state.tweetType == "video"}
                      type="radio"
                      onChange={(e) => {
                        this.setState({ tweetType: "video" }, () =>
                          this.updateDataInParent()
                        );
                      }}
                    ></input>
                    <text>Video</text>
                  </div>
                </div>
              ) : null}
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "facebookLink"}
                  onChange={() => {
                    this.handleSocialMedia("facebookLink");
                  }}
                ></input>
                <text for={"Fb Link"}>{"Fb Link"}</text>
              </div>
              {urlType == "facebookLink" ? (
                <div>
                  <input
                    value={this.state.facebookLink}
                    type="text"
                    onChange={(e) => {
                      this.setState(
                        { facebookLink: e.target.value?.trim() },
                        () => this.updateDataInParent()
                      );
                    }}
                  ></input>
                </div>
              ) : null}
            </details>
          </div>
        );
      case "other":
        return (
          <div>
            <details>
              <summary>Other :</summary>
              <div style={{ marginRight: 10 }}>
                <input
                  value={urlType}
                  type="radio"
                  checked={urlType == "httpsLink"}
                  onChange={() => {
                    this.handleInsideApp("httpsLink");
                  }}
                ></input>
                <text for={"https Link"}>{"https Link"}</text>
              </div>
              {urlType == "httpsLink" ? (
                <div>
                  <input
                    value={this.state.httpsLink}
                    type="text"
                    onChange={(e) => {
                      this.setState({ httpsLink: e.target.value?.trim() }, () =>
                        this.updateDataInParent()
                      );
                    }}
                  ></input>
                </div>
              ) : null}
            </details>
          </div>
        );
    }
  };

  renderNewContentLinkDetails = () => {
    const { category } = this.state;
    return (
      <div>
        <div>
          <div class="row">
            <div className="col-md-3">
              <div style={{ marginRight: 10 }}>
                <input
                  value={category}
                  type="radio"
                  checked={category == "insideApp"}
                  onChange={() => {
                    this.handleCategory("insideApp");
                  }}
                ></input>
                <text for={"Inside App"}>{"Inside App"}</text>
              </div>
            </div>

            <div className="col-md-3">
              <div style={{ marginRight: 10 }}>
                <input
                  value={category}
                  type="radio"
                  checked={category == "storeLinks"}
                  onChange={() => {
                    this.handleCategory("storeLinks");
                  }}
                ></input>
                <text for={"Store Links"}>{"Store Links"}</text>
              </div>
            </div>

            <div className="col-md-3">
              <div style={{ marginRight: 10 }}>
                <input
                  value={category}
                  type="radio"
                  checked={category == "socialMedia"}
                  onChange={() => {
                    this.handleCategory("socialMedia");
                  }}
                ></input>
                <text for={"Social Media"}>{"Social Media"}</text>
              </div>
            </div>

            <div className="col-md-3">
              <div style={{ marginRight: 10 }}>
                <input
                  value={category}
                  type="radio"
                  checked={category == "music"}
                  onChange={() => {
                    this.handleCategory("music");
                  }}
                ></input>
                <text for={"Music"}>{"Music"}</text>
              </div>
            </div>

            <div className="col-md-3">
              <div style={{ marginRight: 10 }}>
                <input
                  value={category}
                  type="radio"
                  checked={category == "other"}
                  onChange={() => {
                    this.handleCategory("other");
                  }}
                ></input>
                <text for={"Other"}>{"Other"}</text>
              </div>
            </div>
            {this.renderCategoryDetails()}
          </div>
          <div>
            <div>
              <label>Button Style:</label>
              <div>
                <div style={{ marginRight: 5 }}>
                  <input
                    type="radio"
                    checked={this.state.buttonStyle == "default"}
                    onClick={() => {
                      this.setState({ buttonStyle: "default" }, () =>
                        this.updateDataInParent()
                      );
                    }}
                  ></input>
                  <text for={"default"}>{"Default"}</text>
                </div>
                <div>
                  <input
                    type="radio"
                    checked={this.state.buttonStyle == "hyperlink"}
                    onClick={() => {
                      this.setState(
                        {
                          buttonStyle: "hyperlink",
                          linkSubText: "",
                          linkAvatar: "",
                        },
                        () => this.updateDataInParent()
                      );
                    }}
                  ></input>
                  <text for={"hyperlink"}>{"HyperLink"}</text>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  pushImageObj = (imageObj) => {
    // const { storyCardImages } = this.state
    // storyCardImages.push(imageObj)
    // this.handleStoryCardImages(storyCardImages)
    this.setState(
      { linkAvatar: imageObj.key, linkAvatarImageObj: imageObj },
      () => {
        this.updateDataInParent();
      }
    );
  };

  render() {
    const {
      peopleModalVisible,
      pagesModalVisible,
      listModalVisible,
      collectionModalVisible,
      buttonDiscardModal,
      markdownLabelModal,
      markdownLabel,
      linkAvatar,
      linkAvatarImageObj,
    } = this.state;
    const cdnurl = AwsConfig.cdn_url;
    const linkAvatarDisplayImage = linkAvatarImageObj?.value
      ? linkAvatarImageObj.imageValue
      : linkAvatar
      ? cdnurl + linkAvatar
      : "";

    return (
      <div>
        {this.renderNewContentLinkDetails()}
        <Modal
          show={pagesModalVisible}
          onHide={() => this.setState({ pagesModalVisible: false })}
        >
          <Modal.Body>{this.renderPagesModal()}</Modal.Body>

          <Modal.Footer>
            <Button onClick={() => this.setState({ pagesModalVisible: false })}>
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={peopleModalVisible}
          onHide={() => this.setState({ peopleModalVisible: false })}
        >
          <Modal.Body>{this.renderPeopleModal()}</Modal.Body>

          <Modal.Footer>
            <Button
              onClick={() => this.setState({ peopleModalVisible: false })}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={listModalVisible}
          onHide={() => this.setState({ listModalVisible: false })}
        >
          <Modal.Body>{this.renderListModal()}</Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.setState({ listModalVisible: false })}>
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={collectionModalVisible}
          onHide={() => this.setState({ collectionModalVisible: false })}
        >
          <Modal.Body>{this.renderCollectionModal()}</Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => this.setState({ collectionModalVisible: false })}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={markdownLabelModal}
          onHide={() => this.setState({ markdownLabelModal: false })}
        >
          <Modal.Body>
            {this.props.markdownLinkLables?.length ? (
              <div>
                {this.props.markdownLinkLables.map((item) => {
                  return (
                    <div>
                      <input
                        type="radio"
                        checked={this.state.markdownLabel == item}
                        onClick={() => {
                          this.setState({ markdownLabel: item }, () => {
                            this.updateDataInParent();
                          });
                        }}
                      ></input>
                      <text>{item}</text>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div>
                <text>Description text doesn't contains Markdown labels</text>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => this.setState({ markdownLabelModal: false })}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={buttonDiscardModal}
          onHide={() => this.hideButtonDiscardModal()}
        >
          <Modal.Body>All Button Changes Will Be Discarded</Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.hideButtonDiscardModal()}>
              Cancel
            </Button>
            <Button onClick={() => this.discardButtonChanges()}>Ok</Button>
          </Modal.Footer>
        </Modal>
        <div>
          <div style={{ marginRight: 5 }}>
            <input
              type="checkbox"
              checked={this.state.enableMarkdownLink}
              onClick={() => {
                this.setState(
                  {
                    enableMarkdownLink: !this.state.enableMarkdownLink,
                    buttonPositionFromTop: "",
                    buttonPositionFromLeft: "",
                    linkText: "",
                    linkSubText: "",
                    linkAvatar: "",
                    markdownLabel: "",
                  },
                  () => this.updateDataInParent()
                );
              }}
            ></input>
            <text for={"Markdown Link"}>{"Markdown Link (inside text)"}</text>
          </div>
        </div>
        {this.state.enableMarkdownLink ? (
          <div>
            <button
              onClick={() => {
                this.setState({ markdownLabelModal: true });
              }}
            >
              Choose Markdown Label
            </button>
            <text style={{ marginLeft: 5 }}>{this.state.markdownLabel}</text>
          </div>
        ) : (
          <div>
            <label>Button Position, Text :</label>
            <div>
              <div>
                <div style={{ marginRight: 5 }}>
                  <input
                    type="radio"
                    checked={this.state.buttonPosition == "custom"}
                    onClick={() => {
                      this.setState({ buttonPosition: "custom" }, () =>
                        this.updateDataInParent()
                      );
                    }}
                  ></input>
                  <text for={"custom"}>{"Custom"}</text>
                </div>
                <input
                  type="radio"
                  checked={this.state.buttonPosition == "default"}
                  onClick={() => {
                    this.setState(
                      {
                        buttonPosition: "default",
                        linkText: "Watch On",
                        linkSubText: "",
                        linkAvatar: "",
                      },
                      () => this.updateDataInParent()
                    );
                  }}
                ></input>
                <text for={"default"}>{"Default"}</text>
              </div>
            </div>
            {this.state.buttonPosition == "custom" ? (
              <div>
                <div>
                  <text>Button Position from Top:</text>
                  <div>
                    <input
                      value={this.state.buttonPositionFromTop}
                      type="number"
                      onChange={(e) => {
                        this.setState(
                          { buttonPositionFromTop: e.target.value },
                          () => this.updateDataInParent()
                        );
                      }}
                    ></input>
                  </div>
                </div>
                <div>
                  <text>Button Position from Left:</text>
                  <div>
                    <input
                      value={this.state.buttonPositionFromLeft}
                      type="number"
                      onChange={(e) => {
                        this.setState(
                          { buttonPositionFromLeft: e.target.value },
                          () => this.updateDataInParent()
                        );
                      }}
                    ></input>
                  </div>
                </div>
              </div>
            ) : null}
            <div>
              <text>Button Text :</text>
              <div>
                <input
                  value={this.state.linkText}
                  type="text"
                  onChange={(e) => {
                    this.setState({ linkText: e.target.value }, () =>
                      this.updateDataInParent()
                    );
                  }}
                ></input>
              </div>
            </div>
            {this.state.buttonPosition == "custom" &&
            this.state.buttonStyle != "hyperlink" ? (
              <div>
                <div>
                  <text>Button Subtext :</text>
                  <div>
                    <input
                      value={this.state.linkSubText}
                      type="text"
                      onChange={(e) => {
                        this.setState({ linkSubText: e.target.value }, () =>
                          this.updateDataInParent()
                        );
                      }}
                    ></input>
                  </div>
                </div>
                <div>
                  <text>Button Image:</text>
                  <ImageUpload
                    pushImageObj={this.pushImageObj}
                    multiImages={false}
                    circularCrop={true}
                  />
                  {linkAvatarDisplayImage && (
                    <img
                      style={{
                        maxWidth: "100%",
                        height: heightPercentageToDP("8"),
                        borderRadius: widthPercentageToDP("10"),
                      }}
                      src={linkAvatarDisplayImage}
                    />
                  )}
                </div>
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export default CreateDynamicButton;
